import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';
import classes from './styles.module.scss';
import { useUserStore } from '../../../../../store';
import AutoButton from '../../../../AutoButton';

export default function CandidatesListHeader({
  totalCount,
  showAddCandidatePopup,
}) {
  const { t } = useTranslation();
  const isClient = useUserStore((state) => state.isClient);
  const navigate = useNavigate();

  return (
    <header className={classes.CandidatesListHeader}>
      <div>
        <h1>
          {t(
            'dashboardComponents.Candidates.CandidatesList.CandidatesListHeader.candidates'
          )}
        </h1>
        <div className={classes.totalCount}>
          <h6 className={classes.heading}>
            {' '}
            {t(
              'dashboardComponents.Candidates.CandidatesList.CandidatesListHeader.totalCandidates'
            )}
          </h6>
          <span>{totalCount || 0}</span>
        </div>
      </div>
      {!isClient && (
        <div className={classes.buttons}>
          <AutoButton
            variant="gradient"
            height={45}
            onClick={() => showAddCandidatePopup(false)}
          >
            Add Candidate
          </AutoButton>

          <AutoButton
            height={45}
            variant="blackWhite"
            onClick={() => navigate('/tools/intel-search')}
          >
            Candidate Search
          </AutoButton>
        </div>
      )}
    </header>
  );
}
